'use client';
import { FC } from 'react';

import { Notification } from '@purpur/library';
import type { EntryFields } from 'contentful';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { RichTextContent } from '@telialt/common-rich-text-content/src/RichTextContent';

import { LEAD_TEST_IDS } from '../constants';

type Props = { message: EntryFields.RichText };

export const LeadSuccessNotification: FC<Props> = ({ message }) => {
    const { t } = useTranslations();

    return (
        <Notification
            headingTag="h3"
            heading={t['content.lead.success.title']}
            status="success"
            data-test={LEAD_TEST_IDS.SUCCESS_NOTIFICATION}
        >
            {message && <RichTextContent richText={message} />}
        </Notification>
    );
};
